module.exports = __webpack_public_path__ + "static/media/feature-tile-icon-03.0f17d4c0.svg";